import { createContext, useContext } from "react";
import { useNavigate, useSearchParams } from "react-router-dom";

/**
 * Qué hacer cuando el login termina (código, Google o Facebook).
 *
 * Por defecto se va a /status, como siempre. Quien abra el LoginModal puede
 * pasar `onLoggedIn` para quedarse en su pantalla: el onboarding con IA lo usa
 * para generar la tienda sobre la cuenta recién abierta en vez de abandonar
 * la vista previa.
 */
export const LoginSuccessContext = createContext<{
  onLoggedIn?: (accessToken: string) => void;
}>({});

export const useAfterLogin = () => {
  const { onLoggedIn } = useContext(LoginSuccessContext);
  const navigate = useNavigate();
  const [searchParams] = useSearchParams();
  const onboardingSplit = searchParams.get("onboarding");

  return (accessToken: string) => {
    if (onLoggedIn) {
      onLoggedIn(accessToken);
      return;
    }
    navigate(
      `/status${onboardingSplit ? `?onboarding=${onboardingSplit}` : ""}`,
    );
  };
};
